<template>
  <v-card class="page--generate_reports" flat>
    <v-card-text class="text-xs-center">
      <h2 class="page-title">Generate Custom Reports</h2>
      <v-layout row wrap justify-center class="report-field-group">
        <v-flex xs12 md10>
          <h3 class="text-xs-left title">Reports Submitted per Team Member:</h3>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            ref="teamUsageStartDate"
            :class="'mr-3'"
            lazy
            :close-on-content-click="true"
            v-model="teamUsage.values.startDateMenu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            :return-value.sync="teamUsage.values.startDate"
          >
            <v-text-field
              slot="activator"
              label="Start Date"
              v-model="teamUsage.values.startDate"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="teamUsage.values.startDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="teamUsage.values.startDate = null">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.teamUsageStartDate.save(teamUsage.values.startDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            ref="teamUsageEndDate"
            :class="'mr-3'"
            lazy
            :close-on-content-click="true"
            v-model="teamUsage.endDateMenu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            :return-value.sync="teamUsage.values.endDate"
          >
            <v-text-field
              slot="activator"
              label="End Date"
              v-model="teamUsage.values.endDate"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="teamUsage.values.endDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="teamUsage.values.endDate = null">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.teamUsageEndDate.save(teamUsage.values.endDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2>
          <v-btn
            primary
            block
            :disabled="teamUsageInvalid"
            download
            :href="generateReportUrl('teamUsage')"
          >
            <v-icon left>assignment</v-icon>
            <span class="btn__text">Get Report</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
  .page--generate_reports {
    .btn--loader {
      .btn__content {
        opacity: 1;
        .icon {
          opacity: 0;
        }
      }
      .btn__loading {
        width: 55px;
      }
    }
  }
</style>

<script>
import Vue from 'vue';
import moment from 'moment-business-days'
import * as ROUNDS_API from '@/constants/roundsApiEndpoints'

export default {
  name: 'sync',
  data() {
    return {
      teamUsage: {
        values: {
          startDate: null,
          endDate: null
        },
        reportUrl: '',
        startDateMenu: false,
        endDateMenu: false
      }
    };
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    teamUsageInvalid() {
      return (this.teamUsage.values.startDate && this.teamUsage.values.endDate && moment(this.teamUsage.values.startDate, 'YYYY-MM-DD').startOf('day').format('x') > moment(this.teamUsage.values.endDate, 'YYYY-MM-DD').endOf('day').format('x'))
    }
  },
  methods: {
    generateReportUrl(reportId) {
      var base_url = ROUNDS_API['API_ENDPOINT_GENERATE_REPORT']
      var query_string = Object.entries(
          Object.assign({
          teamId: this.teamId,
          reportId: reportId
        }, this[reportId].values)
      ).filter(([key, value]) => {
        return !!value
      }).map(([key, value]) => {
        switch(key) {
          case 'startDate':
            value = moment(value, 'YYYY-MM-DD').startOf('day').format('x')
            break
          case 'endDate':
            value = moment(value, 'YYYY-MM-DD').endOf('day').format('x')
            break
        }
        return `${key}=${value}`
      }).join('&')
      var report_url = `${base_url}?${query_string}`
      return report_url
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GenerateReports.vue